import { Container } from "@mui/material";
import React, { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "@emotion/styled";
import { SectionWrapper } from "../../styles";

const CustomAccordionDetails = styled(AccordionDetails)`
  background-color: #100f0f;
`;
const FaucetLink = styled.a``;

const Index = () => {
  const [expanded, setExpanded] = useState("false");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <SectionWrapper p="5rem 0 2rem 0" p599="5rem 0">
      <Container maxWidth="xl" data-aos="fade-up" data-aos-duration="9000">
        <Accordion
          style={{
            backgroundColor: "#004F64",
          }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            style={{
              backgroundColor: "#004F64",
              padding: "0 20px",
            }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "ROCK",
                backgroundColor: "#004F64",
                padding: "10px 0px",
                width: "100%",
                flexShrink: 0,
              }}
            >
              How can I get testnet POA tokens ?
            </Typography>
          </AccordionSummary>
          <CustomAccordionDetails>
            <Typography
              sx={{
                backgroundColor: "#100F0F",
                width: "100%",
                flexShrink: 0,
                padding: "20px 0px",
                fontSize: "16px",
                textAlign: "left",
                fontFamily: "Poppins-Regular",
              }}
            >
              You can navigate to{" "}
              <FaucetLink href="http://faucet.poa.finance/" target="blank">
                Faucet
              </FaucetLink>{" "}
              and grab them.
            </Typography>
          </CustomAccordionDetails>
        </Accordion>
        <Accordion
          style={{
            backgroundColor: "#004F64",
          }}
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "ROCK",
                backgroundColor: "#004F64",
                padding: "10px 0px",
                width: "100%",
                flexShrink: 0,
              }}
            >
              When will POA mainnet launch ?
            </Typography>
          </AccordionSummary>
          <CustomAccordionDetails>
            <Typography
              sx={{
                backgroundColor: "#100F0F",
                width: "100%",
                flexShrink: 0,
                padding: "20px 0px",
                fontSize: "16px",
                textAlign: "left",
                fontFamily: "Poppins-Regular",
              }}
            >
              It will launch at 250k MC.
            </Typography>
          </CustomAccordionDetails>
        </Accordion>
        <Accordion
          style={{
            backgroundColor: "#004F64",
          }}
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "ROCK",
                backgroundColor: "#004F64",
                padding: "10px 0px",
                width: "100%",
                flexShrink: 0,
              }}
            >
              Whats makes POA different from other blockchains ?
            </Typography>
          </AccordionSummary>
          <CustomAccordionDetails>
            <Typography
              sx={{
                backgroundColor: "#100F0F",
                width: "100%",
                flexShrink: 0,
                padding: "20px 0px",
                fontSize: "16px",
                textAlign: "left",
                fontFamily: "Poppins-Regular",
              }}
            >
              It’s different because it is gasless, you don’t have to pay gas
              fees to use it
              <br /> And its fast as well It only takes a second to for the
              transaction to be validated
            </Typography>
          </CustomAccordionDetails>
        </Accordion>
        {/* <Accordion
          style={{
            backgroundColor: "#004F64",
          }}
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "ROCK",
                backgroundColor: "#004F64",
                padding: "10px 0px",
                width: "100%",
                flexShrink: 0,
              }}
            >
              How can I bridge my tokens to mainnet ?
            </Typography>
          </AccordionSummary>
          <CustomAccordionDetails>
            <Typography
              sx={{
                backgroundColor: "#100F0F",
                width: "100%",
                flexShrink: 0,
                padding: "20px 0px",
                fontSize: "16px",
                textAlign: "left",
                fontFamily: "Poppins-Regular",
              }}
            >
              Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed Diam
              Nonumy Eirmod Tempor Invidunt Ut Labore Et Dolore Magna Aliquyam
              Erat, Sed Diam Voluptua. At Vero Eos Et Accusam Et Justo Duo
              Dolores Et Ea Rebum. Stet Clita Kasd Gubergren, No Sea Takimata
              Sanctus Est Lorem Ipsum Dolor Sit Amet. Lorem Ipsum Dolor Sit
              Amet, Consetetur Sadipscing Elitr, Sed Diam Nonumy Eirmod Tempor
              Invidunt Ut Labore Et Dolore Magna Aliquyam Erat, Sed Diam
              Voluptua. At Vero Eos Et Accusam Et Justo Duo Dolores Et Ea Rebum.
              Stet Clita Kasd Gubergren, No Sea Takimata Sanctus Est Lorem Ipsum
              Dolor Sit Amet
            </Typography>
          </CustomAccordionDetails>
        </Accordion> */}
        <Accordion
          style={{
            backgroundColor: "#004F64",
          }}
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: "#fff" }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "ROCK",
                backgroundColor: "#004F64",
                padding: "10px 0px",
                width: "100%",
                flexShrink: 0,
              }}
            >
              How is POA gasless ?
            </Typography>
          </AccordionSummary>
          <CustomAccordionDetails>
            <Typography
              sx={{
                backgroundColor: "#100F0F",
                width: "100%",
                flexShrink: 0,
                padding: "20px 0px",
                fontSize: "16px",
                textAlign: "left",
                fontFamily: "Poppins-Regular",
              }}
            >
              We use a different validation protocol that allows us to run the
              nodes without making the users pay gas, on mainnet, the taxes
              collected on-transfer will pay for the nodes and keep the chain
              free
            </Typography>
          </CustomAccordionDetails>
        </Accordion>
      </Container>
    </SectionWrapper>
  );
};

export default Index;
